import { FiMaximize2, FiMinimize2, FiMessageCircle } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

import * as S from './styles';

type TheaterButtonProps = {
  isTheaterMode: boolean;
  onToggle: () => void;
  variant?: 'default' | 'player' | 'controls';
};

export const TheaterButton = ({
  isTheaterMode,
  onToggle,
  variant = 'default',
}: TheaterButtonProps) => {
  const { t } = useTranslation();

  return (
    <S.TheaterButtonContainer $variant={variant} onClick={onToggle}>
      {isTheaterMode ? <FiMinimize2 /> : <FiMaximize2 />}
      <span>
        {isTheaterMode
          ? t('pages.broadcast.exitTheater', 'Sair do Teatro')
          : t('pages.broadcast.theaterMode', 'Modo Teatro')}
      </span>
    </S.TheaterButtonContainer>
  );
};

type FloatingChatButtonProps = {
  onClick: () => void;
  badgeCount?: number | string | null;
};

export const FloatingChatButton = ({
  onClick,
  badgeCount,
}: FloatingChatButtonProps) => (
  <S.FloatingChatButton onClick={onClick}>
    <FiMessageCircle />
    {badgeCount && <S.FloatingBadge>{badgeCount}</S.FloatingBadge>}
  </S.FloatingChatButton>
);

export default TheaterButton;
